import { render } from "./ImigrationReportIndex.vue?vue&type=template&id=100fc95c&scoped=true"
import script from "./ImigrationReportIndex.vue?vue&type=script&lang=js"
export * from "./ImigrationReportIndex.vue?vue&type=script&lang=js"

import "./ImigrationReportIndex.vue?vue&type=style&index=0&id=100fc95c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100fc95c"]])

export default __exports__